import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-review-by-user',
  templateUrl: './review-by-user.component.html',
  styleUrls: ['./review-by-user.component.css']
})
export class ReviewByUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/components/review-by-user/review-by-user.component.ts